import React from 'react';

import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

import { useCancelPnrImportOrder } from '~/hooks/apis/orders/useCancelPnrImportOrder';

interface Props {
  orderId: string;
  onClose: () => void;
}

/** Confirms cancelling an unpaid imported order, which frees its PNRs to be imported again. */
export default function CancelPnrImportDialog({ orderId, onClose }: Props) {
  const cancelImport = useCancelPnrImportOrder();

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Cancel this import?</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          The unpaid order {orderId} will be cancelled and all of its PNRs can be imported again. The bookings in Sabre
          are not changed.
        </Typography>
        {cancelImport.isError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {cancelImport.error.message}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          disabled={cancelImport.isPending}
          onClick={() => cancelImport.mutate(orderId, { onSuccess: onClose })}
        >
          Cancel import
        </Button>
        <Button variant="text" onClick={onClose}>
          Keep order
        </Button>
      </DialogActions>
    </Dialog>
  );
}
